import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import WorkflowPifSelectField from "./WorkflowPifSelectField";
import WorkflowPifTextField from "./WorkflowPifTextField";
import { PIF_BOOLEAN, PifOption, PifSectionProps } from "./pifDetailsModel";
import { PIF_DETAILS_FIELDS } from "./pifWorkflowKeys";

const F = PIF_DETAILS_FIELDS;

const YES_NO: PifOption[] = [
  { id: PIF_BOOLEAN.yes, text: "Yes" },
  { id: PIF_BOOLEAN.no, text: "No" },
];

/**
 * pif-3 Vehicle & license — driving positions only (AC7, decision 3.3): two required yes / no
 * questions, and the licence number once either is yes. The rules are in validatePifDetails.
 */
const WorkflowPifDrivingSection: React.FC<PifSectionProps> = ({ values, errors, onChange }) => {
  const field = { values, errors, onChange };
  const askLicenseNumber =
    values[F.hasLicense] === PIF_BOOLEAN.yes || values[F.willOperateVehicle] === PIF_BOOLEAN.yes;

  return (
    <>
      <Typography component="h3" className="workflow-run__section-title">
        Vehicle &amp; license
      </Typography>
      <Alert severity="info" className="workflow-run__alert--flush">
        This position may operate an agency vehicle, so the license questions are shown.
      </Alert>
      <Box className="workflow-run__grid workflow-run__grid--spaced">
        <WorkflowPifSelectField
          {...field}
          fieldKey={F.hasLicense}
          label="Holds a driver's licence?"
          options={YES_NO}
          placeholder="Choose one…"
          required
        />
        <WorkflowPifSelectField
          {...field}
          fieldKey={F.willOperateVehicle}
          label="Will operate an agency vehicle?"
          options={YES_NO}
          placeholder="Choose one…"
          required
        />
        {askLicenseNumber && (
          <WorkflowPifTextField
            {...field}
            fieldKey={F.licenseNumber}
            label="Driver license number"
            required
            hint="License state locked to NY."
          />
        )}
      </Box>
    </>
  );
};

export default WorkflowPifDrivingSection;
